import React from 'react';
import { 
  Grid, TextField, Typography, Divider, Box, FormControl, 
  InputLabel, Select, MenuItem, FormHelperText, RadioGroup, 
  FormControlLabel, Radio, FormLabel 
} from '@mui/material';
import { handOverOptions, takenOverOptions } from '../constants/options';

const HandoverDetailsSection = ({ formData, setFormData, errors, handleInputChange, handleBlur }) => {
  return (
    <Box>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 600 }}>Shift Details</Typography>
      <Divider sx={{ mb: 3 }} />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <FormControl component="fieldset">
            <FormLabel component="legend">Histopathology sample shown to patient relatives</FormLabel>
            <RadioGroup
              row
              value={formData.histopathologySample}
              onChange={(e) => setFormData(prev => ({ ...prev, histopathologySample: e.target.value }))}
            >
              <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
              <FormControlLabel value="No" control={<Radio />} label="No" />
            </RadioGroup>
          </FormControl>
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Shifted to Ward/Recovery at"
            name="shiftedToWard"
            type="datetime-local"
            required
            value={formData.shiftedToWard || ""}
            onChange={(e) => handleInputChange("shiftedToWard", e.target.value)}
            onBlur={handleBlur}
            error={!!errors.shiftedToWard}
            helperText={errors.shiftedToWard}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Relative's Name"
            name="relatives_name"
            required
            value={formData.relatives_name || ""}
            onChange={(e) => handleInputChange("relatives_name", e.target.value)}
            onBlur={handleBlur}
            error={!!errors.relatives_name}
            helperText={errors.relatives_name}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl fullWidth required error={!!errors.handOverBy}>
            <InputLabel>Hand Over By</InputLabel>
            <Select
              name="handOverBy"
              value={formData.handOverBy || ""}
              label="Hand Over By"
              onChange={(e) => handleInputChange("handOverBy", e.target.value)}
              onBlur={handleBlur}
            >
              {handOverOptions.map((doc) => (
                <MenuItem key={doc} value={doc}>{doc}</MenuItem>
              ))}
            </Select>
            {errors.handOverBy && <FormHelperText>{errors.handOverBy}</FormHelperText>}
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl fullWidth required error={!!errors.takenOverBy}>
            <InputLabel>Taken Over By</InputLabel>
            <Select
              name="takenOverBy"
              value={formData.takenOverBy || ""}
              label="Taken Over By"
              onChange={(e) => handleInputChange("takenOverBy", e.target.value)}
              onBlur={handleBlur}
            >
              {takenOverOptions.map((doc) => (
                <MenuItem key={doc} value={doc}>{doc}</MenuItem>
              ))}
            </Select>
            {errors.takenOverBy && <FormHelperText>{errors.takenOverBy}</FormHelperText>}
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
};

export default HandoverDetailsSection;
